let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("4DQoU"), load("aQOUn"), load("7FkEF"), load("1i4jB")]).then(() => parcelRequire('48ZOK'));